// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as AccessDeniedPage from "../Error/AccessDeniedPage.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CashRegisterReportsRoutes from "./CashRegisterReportsRoutes.res.js";
import * as CashRegisterReportsListPage from "./CashRegisterReportsListPage.res.js";

function CashRegisterReportsRouter(props) {
  let userRole = Auth.useRole();
  if (Auth.isAuthorizedAccess(userRole, CashRegisterReportsRoutes.baseRoute)) {
    if (props.subUrlPath !== 0) {
      return JsxRuntime.jsx(Navigation.Redirect.make, {
        route: CashRegisterReportsRoutes.baseRoute
      });
    } else {
      return JsxRuntime.jsx(CashRegisterReportsListPage.make, {});
    }
  } else {
    return JsxRuntime.jsx(AccessDeniedPage.make, {});
  }
}

let make = CashRegisterReportsRouter;

export {
  make,
}
/* Auth Not a pure module */
